import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-base text-white"></i>
              </div>
              <span className="text-lg font-bold font-heading">韩漫网</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              韩漫网致力于打造最齐全的韩国漫画平台，提供优质的热门漫画推荐与免费在线阅读体验。每日更新，精彩不间断。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-foreground-200">漫画分类</h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-foreground-200">快速链接</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/about" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
              <Link to="/category/love" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">热门推荐</Link>
              <Link to="/category/fantasy" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">最新上架</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-foreground-200">联系我们</h4>
            <div className="space-y-3 text-sm text-foreground-400">
              <div className="flex items-start gap-2">
                <i className="ri-mail-line text-base mt-0.5"></i>
                <span>contact@hanmanwang.com</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-customer-service-2-line text-base mt-0.5"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩漫网 HanManWang.com - 韩国漫画大全，免费在线阅读
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors text-xs whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors text-xs whitespace-nowrap" rel="nofollow">服务条款</a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors text-xs whitespace-nowrap" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}